import musicImg from "../../../../assets/images/music-card.png";
import styles from "./style.module.scss";
import PropTypes from "prop-types";

const CreditzContainer = ({
  pending = [],
  accepted = [],
  setView,
  setValues,
  updateNotification
}) => {
  const onSelect = (values) => {
    setValues(values);
    setView();
  };
  return (
    <div className={styles.creditzContainer}>
      <p className={styles.categoryTitle}>
        Pending Creditz {pending.length && `(${pending.length})`}
      </p>
      <div className={styles.header}>
        <div className={styles.sender}>Sender</div>
        <div className={styles.artwork}>Artwork</div>
        <div className={styles.type}>Type</div>
        <div className={styles.title}>Title</div>
        <div className={styles.role}>Role</div>
        <div className={styles.date}>Reaction</div>
      </div>
      <div className={`${styles.content} ${styles.pendingCreditz}`}>
        {pending.map((creditz, index) => {
          return (
            <div key={index}>
              <div className={styles.row}>
                <div className={styles.sender}>@{creditz.sender.username}</div>
                <div
                  className={styles.artwork}
                  onClick={() => onSelect(creditz)}
                >
                  <img src={creditz.post.albumImage} alt="musicImg" />
                </div>
                <div className={styles.type}>Music</div>
                <div className={styles.title}>{creditz.post.trackName}</div>
                <div className={styles.role}>
                  <div>Producer</div>
                </div>
                <div className={styles.action}>
                <button className={styles.button_1} onClick={()=>updateNotification(creditz.notification.key, 1)}>Accept</button>
                <button className={styles.button_2} onClick={()=>updateNotification(creditz.notification.key, 2)}>Ignore</button>
                </div>
              </div>
              {index + 1 < pending.length && <hr className={styles.hr} />}
            </div>
          );
        })}
      </div>
      <p className={styles.categoryTitle}>Accepted Creditz</p>
      <div className={`${styles.content} ${styles.acceptedCreditz}`}>
        {accepted.map((creditz, index) => {
          return (
            <div key={index}>
              <div className={styles.row}>
                <div className={styles.sender}>@{creditz.sender.username}</div>
                <div
                  className={styles.artwork}
                  onClick={() => onSelect(creditz)}
                >
                  <img src={creditz.post.albumImage} alt="musicImg" />
                </div>
                <div className={styles.type}>Music</div>
                <div className={styles.title}>{creditz.post.trackName}</div>
                <div className={styles.role}>
                  <div>{creditz.post.role}</div>
                </div>
                <div className={styles.action}>
                  {/*
                    <button className={styles.button_1}>Accept</button>
                    <button className={styles.button_2}>Ignore</button>
                    */}
                </div>
              </div>
              {index + 1 < pending.length && <hr className={styles.hr} />}
            </div>
          );
        })}
        {accepted.length === 0 && (
          <>
            {[0, 1, 2, 3].map((s) => (
              <div key={s} className={styles.emptyAccepted}>
                <hr className={styles.hr} />
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

CreditzContainer.propTypes = {
  pending: PropTypes.array,
  accepted: PropTypes.array,
  setView: PropTypes.func,
  setValues: PropTypes.func,
  updateNotification: PropTypes.func,
};

export default CreditzContainer;
